export type StandardColorTheme = "light" | "dark" | "wistor"

export type WidgetColors = {
  textColor?: string
  bgColor?: string
  borderColor?: string
  ringColor?: string
  hoverTextColor?: string
  hoverBgColor?: string
}

export const EMPTY_WIDGET_COLORS_TEMPLATE = {
  textColor: "",
  bgColor: "",
  borderColor: "",
  ringColor: "",
  hoverTextColor: "",
  hoverBgColor: "",
} satisfies WidgetColors

export const STANDARD_COLORS: Record<StandardColorTheme, Required<WidgetColors>> = {
  light: {
    textColor: "rgb(51 65 85)",              // slate-700
    bgColor: "rgb(255 255 255)",             // white
    borderColor: "rgb(226 232 240)",         // slate-200
    ringColor: "rgb(203 213 225)",           // slate-300
    hoverTextColor: "rgb(0 0 0)",            // black
    hoverBgColor: "rgb(243 244 246)"         // grey-100
  },
  dark: {
    textColor: "rgb(241 245 249)",           // slate-100
    bgColor: "rgb(31 41 55)",                // gray-800
    borderColor: "rgb(55 65 81)",            // gray-700
    ringColor: "rgb(71 85 105)",             // slate-600
    hoverTextColor: "rgb(255 255 255)",      // white
    hoverBgColor: "rgb(55 65 81)"            // grey-700
  },
  wistor: {
    textColor: "rgb(241 245 249)",           // slate-100
    bgColor: "rgb(37 18 89)",                // wistor
    borderColor: "rgb(49 46 129)",           // indigo-900
    ringColor: "rgb(79 70 229)",             // indigo-600
    hoverTextColor: "rgb(255 255 255)",      // white
    hoverBgColor: "rgb(55 48 163)"           // indigo-800
  }
}
